import React, { useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { useLocation } from 'react-router'
import { NavLink, useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'

import header_person from '@/assets/common/header_icon.png'
import HeaderLogo from '@/assets/common/header_logo.png'
import { TYPE_LOGOUT, TYPE_SESSION } from '@/shared/constant/cmdtype'
import { COLOR } from '@/shared/constant/color'
import {
  APP_STORE_WARD,
  IOS_APP_STORE_WARD,
  MO_APP_STORE_WARD,
  SERVICE_JOIN_URL,
} from '@/shared/constant/url'
import { UserLogoutQueryData, UserSessionQueryData } from '@/shared/hooks/reactquery'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import { HeaderUserTab } from '@/shared/store'
import { deviceDetection } from '@/shared/utils'
import { BtnW92H44, BtnW172H44 } from '@/styles/common/CommonForm/buttonform'
import { PcHeaderLeft, PcHeaderRight, PcHeaderUserTab, PcHeaderWrap } from '@/styles/common/header'

const UserSubTab = [
  { title: '마이페이지', link: '/userPage/main' },
  { title: '패밀리레터', link: '/userPage/letter/health' },
  { title: '오늘의 운세', link: '/userPage/fortune' },
]

const PcHeader = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [UserTab, setUserTab] = useRecoilState(HeaderUserTab)
  const [cookies, , removeCookie] = useCookies(['Famliycare'])
  const { data: UserSession, isSuccess } = UserSessionQueryData(TYPE_SESSION, cookies?.Famliycare)
  const { width } = useWindowDimensions()
  const { mutateAsync: UserLogout } = UserLogoutQueryData(TYPE_LOGOUT, cookies?.Famliycare)
  const loginStatus = UserSession?.Header?.ErrMsg === '정상' && cookies?.Famliycare !== undefined
  const Logout = () => {
    UserLogout()
      .then(async (r) => {
        await removeCookie('Famliycare', { path: '/' })
        navigate('/')
        setUserTab(false)
      })
      .catch(() => {
        window.location.reload()
      })
  }

  const onClickAppDownload = () => {
    switch (deviceDetection()) {
      case 'AOS':
        window.open(width > 1200 ? APP_STORE_WARD : MO_APP_STORE_WARD)
        break
      case 'IOS':
        window.open(IOS_APP_STORE_WARD)
        break
    }
  }

  useEffect(() => {
    if (isSuccess) {
      switch (true) {
        case !loginStatus && pathname.includes('/userPage'):
        case loginStatus && pathname.includes('/login'):
          return navigate('/')
      }
    }
  }, [isSuccess, loginStatus, navigate, pathname])

  return (
    <PcHeaderWrap>
      <PcHeaderLeft>
        <img src={HeaderLogo} alt="헤더 이미지" onClick={() => navigate('/')} />
      </PcHeaderLeft>
      <PcHeaderRight>
        <a href={SERVICE_JOIN_URL}>서비스 가입</a>
        <NavLink to={'/notice'}>고객지원</NavLink>
        <NavLink to={'/cancel'}>서비스해지</NavLink>
        <section>
          <BtnW172H44 color={`${COLOR.point1}`} onClick={onClickAppDownload}>
            앱 설치하기
          </BtnW172H44>
          {isSuccess && loginStatus ? (
            <img
              src={header_person}
              alt={'direct_userpage'}
              onClick={() => setUserTab((prev) => !prev)}
            />
          ) : (
            <BtnW92H44>
              <NavLink to={'/login'}>로그인</NavLink>
            </BtnW92H44>
          )}
        </section>
      </PcHeaderRight>
      <PcHeaderUserTab display={`${UserTab}`}>
        {UserSubTab.map((element: any, index: number) => (
          <NavLink
            to={element.link}
            key={index}
            style={{
              color: `${pathname.indexOf(element.link) >= 0 ? COLOR.gray50 : COLOR.gray40}`,
            }}
          >
            {element.title}
          </NavLink>
        ))}
        <p onClick={Logout}>로그아웃</p>
      </PcHeaderUserTab>
    </PcHeaderWrap>
  )
}

export default PcHeader
